module.exports = "/fonts/eppt-logotype-l-2c20c797536462155c22f0a40ee41310.svg";